'use client'
import { useRouter, useSearchParams } from 'next/navigation'

import { SearchComponent } from './SearchComponent'

const SearchHeadBar = () => {
  const { replace } = useRouter()
  const query = useSearchParams()
  const keySearch = query.get('search')
  return (
    <SearchComponent
      debounceSecond={1}
      defaultValue={keySearch || ''}
      handleSearch={(value) => {
        if (value) {
          replace(`/explore?search=${value?.trim()}`)
        }
      }}
    />
  )
}

export default SearchHeadBar
